<div id="loading-container">
	<div *ngFor="let spinner of spinners; let i = index" class="spinner-wrapper">
		<div class="spinner-grow text-primary" [style.animation-delay]="i*0.05 + 's'" role="status">
			<span class="sr-only">Loading...</span>
		</div>
	</div>
</div>